import { Box, Stack, styled, Typography, TypographyProps } from '@mui/material';

export const GuideContainer = styled(Box)(({ theme }) => ({
  maxWidth: 600,
  margin: '0 auto',
  textAlign: 'center',
  padding: '48px 24px',
  backgroundColor: theme.palette.grey[1000],
  color: theme.palette.common.white,
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
}));

export const GuideTitle = styled((props: TypographyProps) => (
  <Typography variant="h3" {...props} />
))(({ theme }) => ({
  color: theme.palette.neutral.min,
}));

export const GuideContent = styled(Stack)(({ theme }) => ({
  width: '432px',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  margin: 'auto 0',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}));

export const GuideStepsContainer = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  marginBottom: 'auto',
}));

export const GuideStep = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
  textAlign: 'left',
  width: '100%',
}));

export const TextNormal = styled((props: TypographyProps) => (
  <Typography variant="body2" component="span" {...props} />
))(({ theme }) => ({
  color: theme.palette.grey[300],
}));

export const TextHighlight = styled((props: TypographyProps) => (
  <Typography variant="body2Bold" component="span" {...props} />
))(({ theme }) => ({
  color: theme.palette.primaries[500],
}));

export const IconWrapper = styled(Box)(({ theme }) => ({
  width: 48,
  height: 48,
  borderRadius: '50%',
  backgroundColor: theme.palette.grey[800],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}));

export const SecurityInfo = styled(Box)(({ theme }) => ({
  marginTop: 'auto',
  paddingTop: theme.spacing(6),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  color: theme.palette.grey[500],
  '& .MuiTypography-root': {
    fontSize: '0.875rem',
  },
}));

export const CountrySelectionDescription = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.body2.fontWeight,
  lineHeight: theme.typography.body2.lineHeight,
  marginBottom: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    textAlign: 'left',
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.body1.fontWeight,
    lineHeight: theme.typography.body1.lineHeight,
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export const HighlightTitle = styled((props: TypographyProps) => (
  <Typography component="span" {...props} />
))(({ theme }) => ({
  color: theme.palette.primaries[500],
  fontSize: theme.typography.h3.fontSize,
  fontWeight: theme.typography.h3.fontWeight,
  lineHeight: theme.typography.h3.lineHeight,
  [theme.breakpoints.up('lg')]: {
    fontSize: theme.typography.h2.fontSize,
    fontWeight: theme.typography.h2.fontWeight,
    lineHeight: theme.typography.h2.lineHeight,
  },
}));
